import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_5 = ({ eyeColours, skinColours }) => {
  const colour0 = '#F15743';
  const colour1 = '#FFFEF0';
  const colour2 = '#F6E7D0';
  const colour3 = eyeColours.shadow;
  const colour4 = '#DF5656';
  const colour5 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M488.6,371.6c2.2-1.9,4.8-6.6,4.6-7.7c-0.3-1-12.3-5.2-12.3-5.2L488.6,371.6z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M443.5,397.8c-3,0.7-8.4-0.1-9-1c-0.6-0.9,2.5-12.4,2.5-12.4L443.5,397.8z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M437.6,383.5c-1-16.4,11-31.7,25.5-32.8c14.5-1.2,27.2,11.1,28.2,27.5c1,16.4-9.9,30.6-24.4,31.8
			C452.3,411.1,438.6,399.9,437.6,383.5z"
          />
          <path
            fill={colour1}
            d="M440.9,382.2c-1-15.8,9-29.5,22.3-30.6c13.3-1.1,24.9,10.8,25.9,26.6c1,15.8-9.1,26.7-22.4,27.8
			C453.3,407.2,441.9,398,440.9,382.2z"
          />
          <path
            fill={colour2}
            d="M465,402.6c13.3-1.1,23.4-12.8,22.4-28.6c-0.2-2.5-0.6-5-1.3-7.3c1.6,3.5,2.6,7.4,2.9,11.6
			c1,15.8-9.1,27.5-22.4,28.6c-11.3,0.9-21.3-6.1-24.6-18C446.4,398.1,455.2,403.4,465,402.6z"
          />
          <path
            fill={colour3}
            d="M449.4,381c-0.8-9.3,5.4-17.6,14-18.5c8.6-0.9,16.2,5.9,17,15.2c0.8,9.3-5.4,17.6-14,18.5
			C457.9,397.1,450.3,390.3,449.4,381z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M434.4,396.7c-0.5-16.5,2.4-34.1,16.4-40.9c12.6-6.1,33.6-3.3,41.7,8.3c-14.8,1.6-37,22.3-50.1,33.8
			C439.1,398.3,435.8,398,434.4,396.7z"
          />
          <path
            fill={colour1}
            d="M472.6,383.3c0-3.3,2-5.9,4.5-6c2.5,0,4.5,2.6,4.5,5.8c0,3.3-2,5.9-4.5,6
			C474.6,389.2,472.6,386.6,472.6,383.3z"
          />
          <path
            fill={colour1}
            d="M470.4,392.4c-1.3-0.4-2.3-1.8-2.3-3.2c0-1.4,1.1-2.3,2.4-1.9c1.3,0.4,2.3,1.8,2.3,3.2
			C472.8,391.9,471.7,392.8,470.4,392.4z"
          />
          <path
            fill={colour5}
            d="M490.6,361.9c-5.7-5.4-43.6-5.5-56.2,31.5c0,0-8.2-29.9,15.2-41.4C476.9,338.6,490.6,361.9,490.6,361.9z"
          />
          <path
            fill={colour5}
            d="M489.6,358.8c2.2,2.9,3.4,5.1,3.4,5.1c-5.9-5.6-36.5,14.3-58.6,32.8c0,0-0.6-1.9-1.4-4.9
			C446,358.9,478.1,355.3,489.6,358.8z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M435,404.1c2.6,4.8,17.4,15.9,31.2,13.8l-6.3,6.4C447.6,422.4,440.1,413.2,435,404.1z"
          />
          <path
            fill={colour5}
            d="M434.5,396.2l60.5-1.2c0,0-16.2,20.7-36.5,16.4C438.3,407,434.5,396.2,434.5,396.2z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M314.1,378.8c-2.5-1.6-5.7-5.9-5.6-6.9c0.1-1.1,11.2-6.9,11.2-6.9L314.1,378.8z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M362,398.2c3,0.2,8.2-1.3,8.7-2.3c0.5-1-4.3-11.9-4.3-11.9L362,398.2z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M365.7,383.2c-1.4-16.3-15.3-29.8-29.7-28.8c-14.4,0.9-24.9,14.9-23.5,31.2c1.4,16.3,14.1,28.8,28.5,27.9
			C355.3,412.6,367.1,399.6,365.7,383.2z"
          />
          <path
            fill={colour1}
            d="M362.3,382.5c-1.3-15.8-13.1-27.9-26.2-27c-13.2,0.8-22.7,14.3-21.4,30.1c1.3,15.8,12.8,25.2,26,24.3
			C353.8,409,363.6,398.2,362.3,382.5z"
          />
          <path
            fill={colour2}
            d="M341.6,406.1c-13.2,0.8-24.7-9.3-26-25.1c-0.2-2.5-0.1-5,0.2-7.4c-1.1,3.7-1.5,7.7-1.1,11.9
			c1.3,15.8,12.9,25.9,26,25.1c11.2-0.7,19.9-9.1,21.5-21.3C359.2,399,351.4,405.4,341.6,406.1z"
          />
          <path
            fill={colour3}
            d="M353.7,382.5c-0.5-9.3-7.9-16.6-16.4-16.3c-8.5,0.3-14.9,8.2-14.4,17.5c0.5,9.3,7.9,16.6,16.4,16.3
			C347.8,399.6,354.3,391.8,353.7,382.5z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M370.7,395.8c-1.9-16.4-7.4-33.3-22-38.1c-13.2-4.3-33.3,1.6-39.6,14.2c14.7-0.5,39.4,16.7,53.9,26.3
			C366.3,398.1,369.6,397.4,370.7,395.8z"
          />
          <path
            fill={colour1}
            d="M346.7,394.5c2.3-2.3,2.8-5.6,1.1-7.3c-1.7-1.7-4.9-1.3-7.2,1c-2.3,2.3-2.8,5.6-1.1,7.3
			C341.2,397.3,344.4,396.8,346.7,394.5z"
          />
          <path
            fill={colour1}
            d="M334.9,396.8c1.2-0.5,2-2.1,1.8-3.5c-0.2-1.4-1.4-2.1-2.6-1.6c-1.2,0.5-2,2.1-1.8,3.5
			C332.5,396.6,333.7,397.3,334.9,396.8z"
          />
          <path
            fill={colour5}
            d="M310.7,369.4c4.8-6.1,41.8-11.7,59.6,23.1c0,0,3.7-30.7-20.9-38.7C320.7,344.4,310.7,369.4,310.7,369.4z"
          />
          <path
            fill={colour5}
            d="M311.2,366.3c-1.7,3.2-2.6,5.5-2.6,5.5c5-6.4,37.8,9.7,62.1,24.1c0,0,0.3-1.9,0.6-5.1
			C353.8,360.1,321.9,361.1,311.2,366.3z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M371.2,403.3c-1.8,5.1-14.7,18.2-28.5,18.1l7.1,5.4C361.6,423.1,367.6,413,371.2,403.3z"
          />
          <path
            fill={colour5}
            d="M370.6,395.3l-59.3,7.4c0,0,18.9,18.2,38.1,11C368.5,406.6,370.6,395.3,370.6,395.3z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_5;
